import { Link, useNavigate, useParams } from 'react-router-dom'
import {
  useEsportazione,
  usePartialUpdateEsportazione,
} from '../../hooks/esportazioni'
import { Alert, Badge, Button, Card, Modal, Spinner } from 'react-bootstrap'
import dayjs from 'dayjs'
import CardStoricoEsportazione from './CardStoricoEsportazione'
import StickyTable from '../../components/StickyTable'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Esportazione } from '../../types'
import ModalInterventiEsportazione from './ModalInterventiEsportazione'
import { getLabelTipoBilancia } from '../../utils/utils'
import { fetchApi } from '@inmagik/react-crud'
import { API_URL } from '../../constants'
import { useAuth } from '../../auth'
import { useEffect, useMemo, useRef, useState } from 'react'
import ModalConfirm from '../../components/ModalConfirm'
import { toast } from 'react-toastify'
import saveAs from 'file-saver'
import { groupBy } from 'lodash'
import { CardTable } from '../../components/StickyTable'

export default function EsportazioneDettaglio() {
  const { id } = useParams()
  const esportazione = useEsportazione(String(id))
  const { mutateAsync: updatePartialEsportazione, isPending } =
    usePartialUpdateEsportazione()
  const [modalStateInterventi, modalActionsInterventi] =
    useModalTrigger<Esportazione>()
  const { tokens } = useAuth()
  const [isOpenEditDelete, setIsOpenEditDelete] = useState(false)

  const editDeleteRef = useRef<HTMLDivElement>(null)

  const [modalStateDelete, modalActionsDelete] = useModalTrigger<Esportazione>()
  const [modalStateConfirm, modalActionsConfirm] = useModalTrigger()
  const [modalStateConfirmSvuota, modalActionsConfirmSvuota] = useModalTrigger()

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        editDeleteRef.current &&
        !editDeleteRef.current.contains(event.target as Node)
      ) {
        setIsOpenEditDelete(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [editDeleteRef])

  const router = useNavigate()

  const numeroPratica = useMemo(() => {
    return esportazione.data?.numero_pratica
  }, [esportazione.data])

  const [statePratica, setStatePratica] = useState(numeroPratica)

  const [isDownloadingEsportazione, setIsDownloadingEsportazione] =
    useState(false)

  const [isTrasmetting, setIsTrasmetting] = useState(false)

  const [isOpenSendEmail, setIsOpenSendEmail] = useState(false)

  const groupedInterventiBySede = useMemo(() => {
    return groupBy(esportazione.data?.interventi_data, (intervento) => {
      return intervento.bilancia_data?.sede_data?.id
    })
  }, [esportazione.data?.interventi_data])

  console.log(groupedInterventiBySede, esportazione.data)

  const [selectedSedi, setSelectedSedi] = useState<number[]>([])

  useEffect(() => {
    if (esportazione.data?.stato === 'trasmessa') {
      setSelectedSedi(Object.keys(groupedInterventiBySede).map(Number))
    }
  }, [esportazione.data?.stato])

  useEffect(() => {
    esportazione.refetch()
  }, [])

  if (esportazione.isLoading) {
    return (
      <div className="page">
        <div className="h-100 d-flex justify-content-center align-items-center">
          <Spinner animation="border" role="status" variant="secondary" />
        </div>
      </div>
    )
  }

  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <div
              onClick={() => {
                router(-1)
              }}
              className="p-sm no-link d-flex align-items-center pointer"
            >
              <span className="material-icons text-secondary">list_alt</span>
              <span className="ms-2">Lista esportazioni</span>
            </div>
            <span className="material-icons text-secondary">chevron_right</span>
            <div className="ms-2 p-sm bg-secondary-light p-2 text-secondary rounded">
              Dettaglio esportazione
            </div>
          </div>
        </div>
        <div className="col-12 d-flex justify-content-between align-items-center mt-2">
          <div className="d-flex align-items-center">
            <h1 className="title me-4">
              Esportazione n° {esportazione.data?.id}
            </h1>
          </div>
          <div className="d-flex align-items-center">
            <div>
              {esportazione.data?.stato === 'trasmessa' && (
                <Button
                  variant="outline-secondary"
                  className="d-flex align-items-center justify-content-center bg-white me-2"
                  onClick={() => setIsOpenSendEmail(true)}
                >
                  <span
                    className="material-icons me-2"
                    style={{
                      fontSize: 16,
                    }}
                  >
                    mail
                  </span>
                  Invia email{' '}
                  {esportazione?.data?.data_invio &&
                    `(${dayjs(esportazione?.data?.data_invio).format(
                      'DD/MM/YYYY'
                    )})`}
                </Button>
              )}
            </div>
            <div>
              <Button
                variant="danger"
                className="d-flex align-items-center justify-content-center"
                onClick={modalActionsConfirmSvuota.toggle}
              >
                <span
                  className="material-icons me-2"
                  style={{
                    fontSize: 16,
                  }}
                >
                  delete
                </span>
                Svuota esportazione
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-5">
          <Card>
            <Card.Body>
              <div className="d-flex align-items-center">
                <div>
                  <div className="label-m">Data esportazione</div>
                  <div className="p-md mt-2 d-flex align-items-center">
                    <span
                      className="material-icons me-2"
                      style={{
                        fontSize: '16px',
                      }}
                    >
                      calendar_today
                    </span>
                    {dayjs(esportazione.data?.data).format('DD/MM/YYYY')}
                  </div>
                </div>
                <div className="ms-4">
                  <div className="label-m">N° interventi</div>
                  <div className="p-md mt-2">
                    {esportazione.data?.numero_interventi}
                  </div>
                </div>
              </div>
              {esportazione.data?.min_data_intervento &&
                esportazione.data?.max_data_intervento && (
                  <div className="mt-3">
                    <div className="label-m">Periodo</div>
                    <div className="p-md mt-2 d-flex align-items-center">
                      <span
                        className="material-icons me-2"
                        style={{
                          fontSize: '16px',
                        }}
                      >
                        calendar_today
                      </span>
                      {dayjs(esportazione.data.min_data_intervento).format(
                        'DD/MM/YYYY'
                      )}{' '}
                      -{' '}
                      {dayjs(esportazione.data.max_data_intervento).format(
                        'DD/MM/YYYY'
                      )}
                    </div>
                  </div>
                )}
            </Card.Body>
          </Card>
          <Card className="mt-4">
            <Card.Body>
              <div>
                <div className="heading-h3">File esportazione</div>
                <div className="mt-3 d-flex align-items-center justify-content-between">
                  <span className="text-body-secondary">
                    Scarica qui il file dell’esportazione.
                  </span>
                  <Button
                    variant="outline-secondary"
                    disabled={
                      esportazione.data?.numero_interventi === 0 ||
                      isDownloadingEsportazione
                    }
                    className="d-flex align-items-center justify-content-center"
                    onClick={async () => {
                      try {
                        setIsDownloadingEsportazione(true)
                        const res = await fetchApi(
                          API_URL +
                            '/bilance/esportazione/' +
                            id +
                            '/scarica-esportazione/',
                          {
                            method: 'POST',
                            headers: {
                              Authorization: `Bearer ${tokens?.access}`,
                            },
                          }
                        )
                        const xml = await res.blob()
                        saveAs(xml, `esportazione_${esportazione.data?.id}.xml`)
                        esportazione.refetch()
                        setIsDownloadingEsportazione(false)
                      } catch (e) {
                        toast.error('Errore durante il download del file', {
                          position: 'bottom-right',
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        })
                        setIsDownloadingEsportazione(false)
                      } finally {
                        setIsDownloadingEsportazione(false)
                      }
                    }}
                  >
                    <span
                      className="material-icons me-2"
                      style={{
                        fontSize: 16,
                      }}
                    >
                      download
                    </span>
                    <span>
                      {esportazione.data?.stato === 'creata'
                        ? 'Scarica'
                        : 'Riscarica'}{' '}
                      esportazione
                    </span>
                    {isDownloadingEsportazione && (
                      <Spinner
                        animation="border"
                        role="status"
                        size="sm"
                        className="ms-4"
                      />
                    )}
                  </Button>
                </div>
                <div className="mt-3 d-flex align-items-center justify-content-between">
                  <span className="text-body-secondary w-75">
                    Se l’esportazione è stata trasmessa a telemaco, inserisci
                    qui il numero di pratica e premi il bottone trasmessa a
                    telemaco.
                  </span>
                  {esportazione.data?.stato === 'trasmessa' ? (
                    <div>
                      <div className="d-flex align-items-center text-success p-sm">
                        <span className="material-icons me-2">check</span>
                        File trasmesso a Telemaco con successo
                      </div>
                      <div className="mt-3">
                        Numero pratica: <br />
                        <Badge color="primary">
                          <strong>{esportazione.data?.numero_pratica}</strong>
                        </Badge>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <input
                        type="text"
                        disabled={
                          esportazione.data?.stato === 'trasmessa' ||
                          esportazione.data?.numero_interventi === 0 ||
                          esportazione.data?.stato === 'creata'
                        }
                        placeholder="Numero pratica"
                        className="form-control"
                        value={statePratica}
                        onChange={(e) => setStatePratica(e.target.value)}
                      />
                      <Button
                        disabled={
                          esportazione.data?.numero_interventi === 0 ||
                          esportazione.data?.stato === 'creata' ||
                          !statePratica ||
                          isTrasmetting ||
                          statePratica === ''
                        }
                        onClick={async () => {
                          try {
                            setIsTrasmetting(true)
                            await fetchApi(
                              API_URL +
                                '/bilance/esportazione/' +
                                id +
                                '/trasmetti-a-telemaco/',
                              {
                                method: 'POST',
                                body: JSON.stringify({
                                  numero_pratica: statePratica,
                                }),
                                headers: {
                                  Authorization: `Bearer ${tokens?.access}`,
                                  'Content-Type': 'application/json',
                                },
                              }
                            ).then((data) => {
                              esportazione.refetch()
                              setIsTrasmetting(false)
                            })
                          } catch (e) {
                            toast.error('Errore durante la trasmissione', {
                              position: 'bottom-right',
                              autoClose: 5000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                            })
                            setIsTrasmetting(false)
                          } finally {
                            setIsTrasmetting(false)
                          }
                        }}
                        variant="success"
                        className="d-flex align-items-center justify-content-center text-white mt-2"
                      >
                        Trasmessa a Telemaco
                        {isTrasmetting && (
                          <Spinner
                            animation="border"
                            role="status"
                            size="sm"
                            className="ms-2"
                          />
                        )}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
          <CardStoricoEsportazione esportazione={esportazione.data} />
        </div>
        <div className="col-md-7">
          <Card>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div className="heading-h5">Interventi inseriti</div>
                {esportazione.data?.stato !== 'trasmessa' && (
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    className="d-flex align-items-center justify-content-center"
                    onClick={modalActionsInterventi.toggle}
                  >
                    <span
                      className="material-icons me-2"
                      style={{
                        fontSize: 16,
                      }}
                    >
                      edit
                    </span>
                    Modifica
                  </Button>
                )}
              </div>
              <StickyTable className="StickyInModal mt-2">
                <thead className="position-sticky top-0 bg-white">
                  <tr>
                    <th>Id</th>
                    <th>Bilancia</th>
                    <th>Cliente</th>
                    <th>Provincia</th>
                    <th>Data intervento</th>
                    <th>Esito</th>
                  </tr>
                </thead>
                <tbody style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  {esportazione.data?.interventi_data?.length === 0 && (
                    <tr>
                      <td colSpan={4} className="text-center">
                        Nessun intervento presente
                      </td>
                    </tr>
                  )}
                  {esportazione.data?.interventi_data?.map((intervento) => (
                    <tr key={intervento.id}>
                      <td>
                        <Link
                          to={`/interventi/${intervento.id}`}
                          className="link-md"
                        >
                          {intervento.id}
                        </Link>
                      </td>
                      <td>
                        <Link
                          to={`/bilance/${intervento.bilancia_data?.id}`}
                          className="link-md text-nowrap"
                        >
                          {intervento.bilancia_data?.matricola}{' '}
                          {intervento.bilancia_data?.sigla
                            ? `(${intervento.bilancia_data?.sigla})`
                            : ''}
                        </Link>
                        <div className="text-body-secondary">
                          {getLabelTipoBilancia(
                            intervento.bilancia_data?.tipo_bilancia
                          )}
                        </div>
                      </td>
                      <td>
                        <Link
                          to={`/clienti/${intervento.pk_cliente}`}
                          className="link-md"
                        >
                          {intervento.nome_cliente}
                        </Link>
                      </td>
                      <td>{intervento.provincia}</td>
                      <td>
                        {dayjs(intervento.data_intervento).format('DD/MM/YYYY')}
                      </td>
                      <td>
                        {intervento.esito === 'positivo' ? (
                          <span className="text-success material-icons">
                            check
                          </span>
                        ) : (
                          <span className="text-danger material-icons">
                            close
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </StickyTable>
            </Card.Body>
          </Card>
        </div>
      </div>
      {modalStateInterventi.isOpen && (
        <ModalInterventiEsportazione
          isOpen={modalStateInterventi.isOpen}
          toggle={() => modalActionsConfirm.open()}
          isOpenConfirm={modalStateConfirm.isOpen}
          isPending={isPending}
          save={async (esportazione) => {
            await updatePartialEsportazione({
              id: Number(id),
              interventi: esportazione.interventi,
            })
            modalActionsInterventi.toggle()
          }}
        />
      )}
      {modalStateDelete.isOpen && (
        <ModalConfirm
          isOpen={modalStateDelete.isOpen}
          toggle={modalActionsDelete.toggle}
          title="Elimina cliente"
          confirmText="Elimina"
          body={
            "Sei sicuro di voler eliminare l'esportazione n° " +
            modalStateDelete.value?.id +
            '?'
          }
          action={async () => {
            await updatePartialEsportazione({
              ...modalStateDelete.value,
              cancellato: true,
            }).then(() => {
              modalActionsDelete.close()
              router('/esportazioni')
              toast.success('Esportazione eliminata con successo', {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              })
            })
          }}
        />
      )}
      {modalStateConfirmSvuota.isOpen && (
        <ModalConfirm
          isOpen={modalStateConfirmSvuota.isOpen}
          toggle={modalActionsConfirmSvuota.toggle}
          title="Attenzione"
          action={async () => {
            await fetchApi(
              API_URL + '/bilance/esportazione/' + id + '/svuota-esportazione/',
              {
                method: 'GET',
                headers: {
                  Authorization: `Bearer ${tokens?.access}`,
                },
              }
            ).then(() => {
              router('/esportazioni')
            })
          }}
          body="Sei sicuro di voler svuotare l'esportazione? Tutti gli interventi verranno riportati allo stato riesaminato e l'esportazione verrà eliminata."
          cancelText="Annulla"
          confirmText="Si svuota"
        />
      )}
      {modalStateConfirm.isOpen && (
        <ModalConfirm
          isOpen={modalStateConfirm.isOpen}
          toggle={modalActionsConfirm.close}
          title="Attenzione"
          action={() => {
            modalActionsInterventi.close()
            modalActionsConfirm.close()
          }}
          body="Sei sicuro di voler chiudere la finestra? Le modifiche non salvate andranno perse."
          cancelText="Annulla"
          confirmText="Si chiudi"
        />
      )}
      <Modal
        show={isOpenSendEmail}
        onHide={() => setIsOpenSendEmail(false)}
        centered
        size="lg"
        backdropClassName="backdrop-high"
        style={{
          zIndex: 1060,
        }}
      >
        <Modal.Header>
          <Modal.Title>Invia email - Certificati Bilance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Ecco il resoconto dei clienti e relativi interventi certificati per
            l'invio mediante email.
          </p>
          <CardTable className="table table-striped">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={
                      selectedSedi.length ===
                      Object.keys(groupedInterventiBySede).length
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedSedi(
                          Object.keys(groupedInterventiBySede).map(Number)
                        )
                      } else {
                        setSelectedSedi([])
                      }
                    }}
                  />
                </th>
                <th>Cliente</th>
                <th>Indirizzo</th>
                <th>Numero certificati</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedInterventiBySede).map((sedeId) => {
                const sede =
                  groupedInterventiBySede[sedeId][0].bilancia_data?.sede_data
                const bilancia =
                  groupedInterventiBySede[sedeId][0].bilancia_data

                return (
                  <tr key={sedeId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedSedi.includes(Number(sedeId))}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedSedi([...selectedSedi, Number(sedeId)])
                          } else {
                            setSelectedSedi(
                              selectedSedi.filter((id) => id !== Number(sedeId))
                            )
                          }
                        }}
                      />
                    </td>
                    <td>
                      <Link
                        to={`/clienti/${bilancia?.cliente_pk}`}
                        className="link-md"
                      >
                        {bilancia?.cliente_ragione_sociale}
                      </Link>
                    </td>
                    <td>
                      {sede.toponimo_data?.nome}{' '}
                      {sede?.via}, {sede?.civico} {sede?.comune_data?.nome} (
                      {sede?.provincia_data?.sigla})
                    </td>
                    <td>{groupedInterventiBySede[sedeId].length}</td>
                    <td>
                      {sede?.email_referente
                        ? sede?.email_referente
                        : bilancia?.email_sede_principale}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </CardTable>
          {/* check if theere are some emails blank and show an alert */}
          {Object.keys(groupedInterventiBySede).some((sedeId) => {
            const sede =
              groupedInterventiBySede[sedeId][0].bilancia_data?.sede_data
            const bilancia = groupedInterventiBySede[sedeId][0].bilancia_data

            return !sede?.email_referente && !bilancia?.email_sede_principale
          }) && (
            <Alert variant="danger">
              Alcuni clienti non hanno l'email del referente o della sede
              principale. Non verranno inviate email a questi clienti.
            </Alert>
          )}
          <Alert variant="info">
            Stai per inviare {selectedSedi.length} e-mail a{' '}
            {selectedSedi.length} clienti.
          </Alert>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between align-items-center">
          <Button
            variant="outline-secondary"
            onClick={() => setIsOpenSendEmail(false)}
          >
            Chiudi
          </Button>
          <Button
            variant="secondary"
            className="text-white d-flex align-items-center"
            onClick={async () => {
              await fetchApi(
                API_URL +
                  '/bilance/esportazione/' +
                  id +
                  '/invia-emails-sedi-certificati/',
                {
                  method: 'POST',
                  body: JSON.stringify({
                    sedi: selectedSedi,
                  }),
                  headers: {
                    Authorization: `Bearer ${tokens?.access}`,
                    'Content-Type': 'application/json',
                  },
                }
              ).then(() => {
                toast.success('Email inviate con successo', {
                  position: 'bottom-right',
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                })
                setIsOpenSendEmail(false)
                esportazione.refetch()
              })
            }}
          >
            <span
              className="material-icons me-2"
              style={{
                fontSize: 16,
              }}
            >
              email
            </span>
            Invia email{' '}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
